<div class="confirm-modal-backdrop" *ngIf="isOpen">
  <div class="confirm-modal" role="dialog" aria-modal="true">
    <div class="modal-body">
      <div class="icon-badge-3d">
        <svg
          width="60"
          height="60"
          viewBox="0 0 100 100"
          xmlns="http://www.w3.org/2000/svg"
        >
          <defs>
            <linearGradient
              id="triGradient"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stop-color="#ff8a75" />
              <stop offset="45%" stop-color="#f0503d" />
              <stop offset="100%" stop-color="#d43324" />
            </linearGradient>
            <linearGradient
              id="triHighlight"
              x1="0%"
              y1="0%"
              x2="100%"
              y2="100%"
            >
              <stop offset="0%" stop-color="#ffffff" stop-opacity="0.55" />
              <stop offset="60%" stop-color="#ffffff" stop-opacity="0" />
            </linearGradient>
            <filter id="triShadow" x="-30%" y="-30%" width="160%" height="160%">
              <feDropShadow
                dx="0"
                dy="4"
                stdDeviation="4"
                flood-color="#c0281a"
                flood-opacity="0.45"
              />
            </filter>
          </defs>

          <!-- base rounded triangle -->
          <path
            d="M50 8 C52 8 54 9 55.5 12 L92 76 C94.5 80.5 91 86 86 86 L14 86 C9 86 5.5 80.5 8 76 L44.5 12 C46 9 48 8 50 8 Z"
            fill="url(#triGradient)"
            filter="url(#triShadow)"
          />

          <!-- inner rim for depth -->
          <path
            d="M50 16 C51 16 51.8 16.5 52.5 17.8 L84.5 74.5 C86 77 84.2 80 81.2 80 L18.8 80 C15.8 80 14 77 15.5 74.5 L47.5 17.8 C48.2 16.5 49 16 50 16 Z"
            fill="none"
            stroke="#ffffff"
            stroke-opacity="0.15"
            stroke-width="2"
          />

          <!-- gloss highlight -->
          <path
            d="M50 8 C52 8 54 9 55.5 12 L74 44 C64 34 54 28 42 30 L44.5 12 C46 9 48 8 50 8 Z"
            fill="url(#triHighlight)"
          />

          <!-- exclamation mark -->
          <rect x="44" y="34" width="12" height="26" rx="6" fill="#fdf6f4" />
          <circle cx="50" cy="70" r="6.5" fill="#fdf6f4" />
        </svg>
      </div>

      <h3 class="modal-title">Are you sure?</h3>
      <p class="modal-message" *ngIf="actionMessage">{{ actionMessage }}</p>

      <!-- <div class="car-list-header">
        <span class="car-list-title">Cars</span>
        <button type="button" class="btn-add" (click)="onAddCar()">
          <span class="btn-add-icon">+</span> Add
        </button>
      </div> -->

      <div class="car-list" *ngIf="!fromVehicle">
        <div class="car-row" *ngFor="let car of cars">
          <ng-container *ngIf="{ id: currentProductId | async } as product">
            <span class="car-name">{{ car?.vehicleName }}</span>

            <label
              class="car-radio"
              [class.sold]="car?.isSold"
              *ngIf="car?.isSold"
            >
              <input
                type="radio"
                [checked]="car?.isSold"
                [disabled]="car?.isSold"
              />
              <span class="radio-mark">
                <svg
                  *ngIf="car?.isSold"
                  width="12"
                  height="12"
                  viewBox="0 0 24 24"
                  fill="none"
                >
                  <path
                    d="M5 13l4 4L19 7"
                    stroke="#ffffff"
                    stroke-width="3"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </span>
            </label>

            <button
              class="btn btn-primary"
              [ngClass]="{
                'btn-success': !car?.isSold,
                'btn-danger': car?.isSold
              }"
              [ladda]="product?.id === car?.productId"
              [disabled]="product?.id === car?.productId || car?.isSold"
              (click)="!car?.isSold ? onProductSold(car?.productId) : undefined"
            >
              {{ car?.isSold ? "Sold" : "Mark as sold" }}
            </button>
          </ng-container>
        </div>

        <div class="car-list-empty" *ngIf="!cars || cars.length === 0">
          No cars yet. Tap "Add" to create one.
        </div>
      </div>

      <div class="btn-row">
        <button type="button" class="btn btn-cancel" (click)="cancleAction()">
          Cancel
        </button>
        <button
          type="button"
          class="btn btn-confirm btn-wide"
          (click)="confirmAction()"
          [ladda]="actionInProgress"
          [disabled]="secondsLeft > 0"
        >
          <span>{{ confirmLable }}</span>
          <span class="timer-count" *ngIf="secondsLeft > 0"
            >({{ secondsLeft }}s)</span
          >
        </button>
      </div>
    </div>
  </div>
</div>
